import { AppId } from '@shared/types'
import { CommonWizardWrapper } from '@ui-common/components/CommonWizardWrapper'
import { use } from 'react'

import { LoanOfferAnalyticsContext } from '../analytics/analyticsContext'
import { AfterCareStep } from '../steps/aftercare/AfterCareStep'
import { BookingStep } from '../steps/booking/BookingStep'
import { FormContext } from '../steps/formContext'
import { InstallmentStep } from '../steps/installment/InstallmentStep'
import { OfferStep } from '../steps/offer/OfferStep'
import { RecommendationStep } from '../steps/recommendation/RecommendationStep'
import { StatusStep } from '../steps/status/StatusStep'
import { TermsInfoStep } from '../steps/termsInfo/TermsInfoStep'
import { useWizardLogic } from './useWizardLogic'
import { WizardContext, WizardStep } from './wizardMachine'

type WizardProps = {
  initialContext: WizardContext
}

export const Wizard = ({ initialContext }: WizardProps) => {
  const { ...formContext } = useWizardLogic(initialContext)
  const { analyticsService } = use(LoanOfferAnalyticsContext)
  const { step, exit, authToken } = formContext

  const stepComponentMap: Partial<Record<WizardStep, () => React.ReactNode>> = {
    [WizardStep.StatusStep]: () => <StatusStep />,
    [WizardStep.OfferStep]: () => <OfferStep />,
    [WizardStep.InstallmentStep]: () => <InstallmentStep />,
    [WizardStep.TermsInfoStep]: () => <TermsInfoStep />,
    [WizardStep.RecommendationStep]: () => <RecommendationStep />,
    [WizardStep.BookingStep]: () => <BookingStep />,
    [WizardStep.AfterCareStep]: () => <AfterCareStep />,
  }

  return (
    <FormContext value={formContext}>
      <CommonWizardWrapper
        stepComponentMap={stepComponentMap}
        step={step}
        appId={AppId.SecLoans}
        analyticsService={analyticsService}
        onLogout={exit}
        authToken={authToken ?? null}
        userContext={null}
      />
    </FormContext>
  )
}
